import birdAr from './birdAr'
import {ar as landingAr} from './landingpage'
import {ar as sconceptAr} from './sconcept';
import {ar as instructionBookAr} from './instructionBook'
import {ar as sellAr} from './sell'
import {ar as detailsAndetcAr} from './detailsAndetc';
import {ar as auctionAr} from './auction';
import {ar as sellUpload} from './sellUpload';

const ar = {
    ...sconceptAr,
    ...landingAr,
    ...birdAr,
    ...instructionBookAr,
    ...detailsAndetcAr,
    ...sellAr,
    ...auctionAr,
    ...sellUpload,
    signIn: 'تسجيل الدخول',
    Cart: 'عربة التسوق',
    Collections: 'المجموعات',
    Downloadapp: 'تنزيل التطبيق',
    login: 'تسجيل الدخول',
    register: 'التسجيل',
    logout: 'تسجيل الخروج',
    WorldofFalcons: 'عالم فالكونز',
    DiscoverFalcons: 'اكتشفوا المزيد',
    Signup: 'التسجيل',
    ContinueAsGuest: 'متابعة كضيف',
    SignUpIn: 'التسجيل/الدخول',
    SignUpAgree: 'بتسجيل انضمامكم، توافقون على البنود التالية',
    TermsOfService: 'الشروط والأحكام',
    TAndC: 'الشروط والأحكام',
    Policy: 'سياسة الخصوصية',
    Email: 'البريد الإلكتروني',
    Password: 'كلمة المرور',
    liveStreaming: 'فتح البطاقات الرياضية',
    liveTag: 'مباشر',
    invitationCodePlaceholder: 'رمز الدعوة (اختياري)',
    EmailAddress: 'البريد الإلكتروني',
    SendResendLink: 'إرسال رابط إعادة تعيين كلمة المرور',
    GoToHomePage: 'الانتقال إلى الصفحة الرئيسية',
    NewPassword: 'كلمة المرور الجديدة',
    SavePassword: 'حفظ كلمة المرور',
    passwordRule: 'يجب ألا تقل كلمة المرور عن 8 أحرف وأن تحتوي على حروف أبجدية وأرقام',
    confirmPasswordRule: 'يرجى تأكيد صحة كلمة المرور الجديدة',
    ConfirmPassword: 'تأكيد كلمة المرور',
    VerificationCode: 'كود التحقق',
    SendToYourEmail: 'تم إرساله إلى بريدكم الإلكتروني',
    DoItLater: 'القيام بذلك لاحقاً',
    CompleteMyProfile: 'استكمال الملف الشخصي',
    HasAccount: 'هل لديك حساب مسبقاً؟',
    emailRule: 'يرجى إدخال عنوان بريد إلكتروني صحيح',
    emailRequired: 'البريد الإلكتروني غير صحيح',
    passwordRequired: 'كلمة المرور غير صحيحة',
    rememberRule: 'قاعدة الاحتفاظ ببيانات الدخول',
    signupRule: 'لتسجيل حساب جديد، يجب أن توافقوا على شروط وأحكام موقع فالكونز',
    ValidateName: 'يرجى إدخال اسم صحيح',
    LogIn: 'تسجيل الدخول',
    LogInGoogle: 'تسجيل الدخول عبر حساب غوغل',
    NoAccount: 'ليس لديكم حساب؟',
    remember: 'تذكر الحساب لمدة 30 يوماً',
    CurrentPassword: 'كلمة المرور الحالية',
    ForgotPassword: 'هل نسيتم كلمة المرور؟',
    ForgotYourPassword: 'هل نسيتم كلمة مروركم؟',
    SetNewPassword: ' تعيين كلمة مرور جديدة',
    NoWorryToResetPassword: 'لا داعي للقلق، سنرسل لكم رسالة لمساعدتكم على إعادة تعيين كلمة المرور الخاصة بكم',
    PasswordChangeSentEmail: 'تم إرسال رابط إعادة تعيين كلمة المرور إلى بريدكم الإلكتروني',
    ConfirmNewPassword: 'تم تعيين كلمة المرور الجديدة بنجاح',
    GoToLogInPage: 'الانتقال إلى صفحة تسجيل الدخول',
    usa: 'دولار أمريكي',
    Searchfor: 'البحث عن',
    searchBrands: 'البحث عن العلامات التجارية',
    Subscribe: 'اشتراك',
    getEmail: 'يرجى إدخال عنوان البريد الإلكتروني لتلقي آخر الأخبار',
    promptText: 'السعر يشمل الضريبة المضافة و تكلفة الشحن والتأمين',
    Sellitem: 'البيع الآن',
    Neverused: 'لم يُستخدم أبداً',
    Viewmore: 'عرض المزيد',
    buy: 'شراء',
    Buynow: 'الشراء الآن',
    Auctions: 'المزادات',
    Remove: 'إزالة',
    PriceDetails: 'تفاصيل السعر',
    ContinueToCheckout: 'المتابعة للدفع',
    Checkout: 'الدفع',
    TotalPayable: 'إجمالي المبلغ المستحق',
    CommissionFee: 'العمولة',
    Edit: 'تعديل',
    shippingFee: 'رسوم الشحن',
    Included: 'يشمل',
    shippingInsurance: 'تكلفة & والتأمين',
    PromoCode: 'رمز الخصم',
    AllInclusive: 'المجموع الإجمالي',
    Total: 'الإجمالي',
    Commission: 'العمولة',
    BackToAuction: 'العودة إلى المزاد',
    TimeForPayment: 'وقت الدفع',
    Startselling: 'البدء بالبيع',
    sellVerifyTitle: 'التحقق مطلوب',
    sellVerifyContent1: 'لضمان أعلى معايير الأصالة والجودة ، ',
    sellVerifyContent2: 'نحن بحاجة إلى تحقق إضافي.',
    sellVerifiyContinue: 'متابعة التحقق',
    SellwithFalcons: 'البيع على موقع فالكونز',
    Locationofitem: 'موقع القطعة',
    Sellingmode: 'وضع البيع',
    Details: 'التفاصيل',
    Photos: 'الصور',
    Review: 'مراجعة',
    Continue: 'متابعة',
    Back: 'عودة',
    CONTINUE: 'متابعة',
    Overview: 'لمحة عامة',
    SellingmodeLocationofitem: 'الموقع والوضع',
    Gender: 'الجنس',
    Category: 'الفئة',
    Brand: 'العلامة التجارية',
    Condition: 'الحالة',
    Description: 'الوصف',
    DescriptionPlaceholder: 'صف العناصر الخاصة بك في جمل قليلة',
    Male: 'ذكر',
    Female: 'أنثى',
    Unisex: 'الجنسين',
    chooseGender: 'يرجى اختيار الجنس',
    chooseCategory: 'يرجى اختيار الفئة',
    chooseBrand: 'يرجى اختيار العلامة التجارية',
    chooseCondition: 'يرجى اختيار حالة القطعة',
    Youritem: 'قطعتك',
    Status: 'الحالة',
    Estimatetime: 'الوقت المقدر',
    Notice: 'ملاحظة',
    Account: 'الحساب',
    Upgrade: 'ترقية',
    Tier: 'المستوى',
    Wonder: 'هل تتساءلون عن القيمة المادية لقطعتكم الفنية؟',
    BasicInfo: 'المعلومات الأساسية',
    LogInfo: 'معلومات الاتصال',
    ShippingAddress: 'عنوان الشحن',
    PhoneNum: 'رقم الهاتف',
    Name: 'الاسم',
    FullName: 'الاسم الكامل',
    Address: 'العنوان',
    addressPlaceholder: 'رقم الشارع، المبنى، إلخ.',
    PaymentMethod: 'طريقة الدفع',
    Birth: 'تاريخ الميلاد',
    Nationality: 'الجنسية',
    Country: 'الدولة',
    CountryCode: 'رمز الدولة',
    FavoriteCategories: 'الفئات المفضلة',
    FavoriteBrands: 'العلامات التجارية المفضلة',
    Save: 'حفظ',
    Sellingitems: 'بيع القطع',
    Vaulteditems: 'القطع الموجودة في الخزنة',
    VaulteditemsText: 'الخزنة: ثق بنا في الحفاظ على سلامة مقتنياتك وتخزين أغراضك لإعادة بيعها.',
    Purchases: 'المشتريات',
    Wallet: 'المحفظة',
    WalletText: "المحفظة: قم بتخزين تفاصيل الدفع الخاصة بك بشكل آمن وادفع على موقع فالكونز.",
    AED: 'الدفع بالبطاقة (درهم إماراتي)',
    Missionboard: 'لوحة المهام',
    Onsale: 'تخفيضات',
    Selected: 'تم اختياره',
    RemoveAllSelected: 'إزالة كل القطع المختارة',
    Lots: 'القطع',
    Frontside: 'الجهة الأمامية',
    Backside: 'الجهة الخلفية',
    BottomView: 'الجهة السفلية',
    optional: 'اختياري',
    TopView: 'الجهة العلوية',
    InsideView: 'الداخل',
    photoTypes: 'JPEG, PNG',
    documents: 'المستندات',
    documentType: 'PDF',
    fileSizeLimit: 'حد حجم الملف',
    fileSizeLimitValue: '20 MB',
    keepInMindTitle: 'لتضع في اعتبارك:',
    closeUpShots: 'لقطات عن قرب: ',
    closeUpShotsContent: 'قم بتضمين لقطات مقربة لعلامات العلامات التجارية والأرقام التسلسلية وأي عيوب.',
    highQualityPhotos: 'صور عالية الجودة: ',
    highQualityPhotosContent: 'قم بتحميل صور عالية الدقة للعنصر من زوايا متعددة (أمامية وخلفية وجانبية وداخلية).',
    whiteBackground: 'خلفية بيضاء: ',
    whiteBackgroundContent: 'يجب التقاط جميع الصور على خلفية بيضاء مع عدم وجود صور أو كائنات مرئية بخلاف العنصر الموجود في الصورة.',
    Myaddress: 'في حوزتي',
    editLocationAndMode: 'تعديل الموقع والوضع',
    editItemDetails: 'تعديل تفاصيل العنصر',
    editPhotos: 'تعديل الصور',
    FalconsVault: 'خزنة فالكونز',
    Proposedmode: 'الوضع المقترح',
    Proposedprice: 'السعر المقترح',
    Accept: 'قبول',
    Continuewithnewmode: 'المتابعة باستخدام الوضع الجديد',
    Continuewithoriginalmode: 'المتابعة باستخدام الوضع الأصلي',
    Reject: 'رفض',
    Confirm: 'تأكيد',
    Step1: 'الخطوة الأولى:',
    Step2: 'الخطوة الثانية:',
    Newproposedprice: 'السعر الجديد المقترح',
    NewProposedPriceDesc: 'لقد تحقق فريق الصقور لدينا بعناية من العنصر الخاص بك ويسره أن يقدم لك أفضل سعر مضمون. نتطلع إلى الترحيب بالعنصر الخاص بك في الصقور.',
    AddtoCart: 'إضافة إلى عربة التسوق',
    AddtoCartSuccess: 'تمت الإضافة بنجاح',
    spuSizePlaceholder: 'اختر المقاس',
    outOfStock: 'غير متوفر',
    releaseDate: 'تاريخ الإصدار',
    AddtoCollections: 'إضافة إلى المجموعات',
    AllinclusiveVAT: 'جميع الأسعار غير شاملة لضريبة القيمة المضافة',
    Authenticitycertification: 'شهادة الأصالة',
    Deliveryworldwide: 'التوصيل إلى جميع أنحاء العالم',
    ExteriorMaterial: 'الخامة الخارجية',
    Includes: 'المرفقات',
    Origin: 'الأصل',
    Height: 'الارتفاع',
    Width: 'العرض',
    Length: 'الطول',
    Beltlength: 'طول الحزام',
    Casediameter: 'قطر العلبة',
    Handledrop: 'طول المقبض',
    Braceletsize: 'مقاس السوار',
    Yearset: 'العام والمجموعة',
    YearText: "العام",
    Features: 'الخصائص',
    Contents: 'المحتويات',
    RookieCards: 'بطاقات المبتدئين',
    SpecialFeatures: 'الخصائص المميزة',
    Removefromcart: 'إزالة من العربة',
    RemovefromCollections: 'إزالة من المجموعات',
    Makeanoffer: 'تقديم عرض',
    Finish: 'إنهاء',
    Pleaseuploadatleast2photos: 'يرجى تحميل صورتين شخصيتين على الأقل',
    Pleaseuploadatleast5photos: 'يرجى تحميل ما لا يقل عن خمس صور',
    Doyouconfirm: 'هل تؤكدون موافقتكم على عرض هذه القطعة؟',
    Notification: 'إشعار',
    MostRecent: 'الأحدث',
    Earlier: 'الأقدم',
    ShowMore: 'عرض المزيد',
    ViewShoppingCart: 'عرض عربة التسوق',
    UpperViewShoppingCart: 'عرض عربة التسوُّق',
    resultTitle: 'نتيجة',
    Online: 'عبر الإنترنت',
    searchPlace: 'بحث',
    Upcomingauctions: 'المزادات القادمة',
    All: 'الكل',
    Sortby: 'الترتيب حسب',
    EndDate: 'وقت الانتهاء:',
    Popular: 'الأكثر شيوعاً',
    Mybids: 'المزايدات الخاصة بكم',
    Conditionsofbusiness: 'الشروط',
    Joinauction: 'الانضمام إلى المزاد',
    JoinAuction: 'الانضمام إلى المزاد',
    BrowseBreaks: 'تصفح العروض الترويجية',
    JoinAuctionITip: 'سيتغير السعر النهائي لطلبكم قليلاً وذلك وفقاً لأسعار التحويل ورسوم التوصيل وضريبة القيمة المضافة.',
    Notifyme: 'حفظ وطلب تلقي الإشعار',
    LengthRule: 'يمكن اختيار ثلاثة عناصر بحد أقصى',
    EnterRule: 'يرجى إدخال',
    PhoneRule: 'يرجى إدخال رقم هاتف صحيح.',
    Suggestedauctions: 'المزادات المقترحة',
    Currentprice: 'السعر الحالي',
    Estimate: 'تقديرنا',
    Placeabid: 'المزايدة بمبلغ أكبر',
    State: 'المنطقة',
    StateName: 'المنطقة',
    City: 'المدينة',
    CityName: 'المدينة',
    PostCode: 'الرمز البريدي',
    VIEWAUCTION: 'عرض المزاد',
    Yourbid: ' المزايدات الخاصة بكم',
    Setmaxbid: 'المزايدة بالحد الأقصى للمبلغ',
    BidPriceChange: 'لقد تغير السعر الحالي. يرجى اختيار سعر آخر.',
    Bidplacedsuccessfully: 'تمت المزايدة بنجاح',
    Gobacktolot: 'العودة إلى القطعة',
    ConfirmAndPay: 'التأكيد والدفع',
    GoBack: 'عودة',
    SelectDeliveryAddress: 'اختيار عنوان التوصيل',
    KeepInVault: 'الاحتفاظ بالقطعة في الخزنة',
    AddressAndContact: 'العنوان وجهة الاتصال',
    OrderSummary: 'ملخص الطلب',
    FirstName: 'الاسم',
    LastName: 'اللقب',
    Estimatedprice: 'السعر المقدر',
    Terminformation: 'الشروط والأحكام',
    ShowAll: 'عرض الكل',
    ShowLess: 'عرض أقل',
    MakeDefaultAddress: ' تحديد هذا العنوان كعنوان أساسي',
    Vat: 'ضريبة القيمة المضافة',
    VerifyAccount: 'التحقق من الحساب',
    VerifyAccountContent1: 'للمشاركة في المزادات المباشرة، علينا التحقق من حسابكم',
    VerifyAccountContent2: 'بخلاف ذلك، سيقتصر وصولك على سوق الشراء والمزادات عبر الإنترنت',
    WhyNeed: 'لماذا نحتاج إلى التحقق من حسابكم؟ ',
    WhyNeed1: 'لتمكينكم من المشاركة في المزادات المباشرة والوصول إلى المزيد من المجموعات الثمينة.',
    WhyNeed2: `لاستكمال عملية 'اعرف عميلك' ومساعدتنا في بناء بيئة تسوّق نظيفة وآمنة.`,
    newVerifyUploadTip: 'يرجى تقديم صور واضحة للمستند ومن دون عوائق. يجب أن يتطابق الاسم الموجود في المستند مع الاسم المسجل.',
    WhyNeed3: 'لتقديم خدمة متميزة لعملائنا الحصريين.',
    SelectOnComputer: 'اختيار المستندات من الكمبيوتر',
    uploadFile: 'تحميل الملف',
    DoLater: 'سأقوم بذلك لاحقاً',
    UserIdentification: 'بطاقة هوية (رخصة القيادة، جواز السفر، إلخ)',
    newUserIdentification: 'بطاقة الهوية (رخصة القيادة، جواز السفر)',
    verContactUs: 'تواصل معنا',
    newEstTime: 'المدَّة المقدَّرة:',
    newWhyNeed: 'لماذا يجب عليكم إتمام عملية التحقُّق من حسابكم؟',
    newDocumentReview: 'قيد المراجعة',
    PaymentHistory: 'سجل المدفوعات',
    AuctionHistory: 'سجل مشتريات المزاد',
    FinancialStatement: 'التقرير المالي',
    CreditStatement: 'بيان حد البطاقة الائتمانية',
    CryptocurrencyAccount: 'حساب العملات المشفرة',
    PropertyStatement: 'بيان قيمة العقار',
    UploadLeastTwo: 'يرجى تحميل بطاقة الهوية',
    UploadedDocuments: 'المستندات المحملة',
    AddAnotherDocument: 'إضافة مستند آخر',
    BackToShopping: 'العودة إلى التسوق',
    DocumentReview: 'مراجعة المستندات',
    VerificationStatus: 'حالة عملية التحقق',
    Saved: 'تم الحفظ',
    PendingReview: 'قيد المراجعة',
    Approved: 'موافَق عليه',
    Rejected: 'مرفوض',
    verifyUploadTip: 'يرجى تقديم صور واضحة لمستنداتكم. يجب أن يتطابق الاسم الوارد في الوثيقة مع الاسم المسجل لدينا.',
    Today: 'اليوم',
    Yesterday: 'الأمس',
    MarkAll: 'اعتبار جميع الرسائل مقروءة',
    MakeanofferDec01: 'هل السعر مرتفع للغاية؟',
    MakeanofferDec02: 'يمكنكم تقديم عرض للبائع وإخباره بالسعر الذي تريدونه',
    proposeprice: 'اقتراح سعر مختلف',
    Cancel: 'إلغاء',
    Pleaseentertheprice: 'يرجى إدخال السعر',
    Thepricecannotbelowerthantheinitialprice: 'لا يمكن أن يكون السعر أقل من السعر الأدنى',
    newoffer: 'لقد قدمتم عرضًا جديدًا بمبلغ',
    Buyat: 'شراء هذه القطعة بسعر',
    Offeredprice: 'عرض المشتري',
    Action: 'الإجراء',
    Price: 'السعر',
    Yourofferof: 'العرض الذي قمتم بتقديمه بمبلغ',
    hasbeenaccepted: 'تم قبوله',
    UploadIdMust: 'يرجى تحميل بطاقة الهوية أولاً',
    Hours: 'الساعات',
    EstimatedTime: 'الوقت المقدر',
    Code: 'الرمز',
    Hotdeals: 'الامتيازات',
    Newarrivals: 'وصل حديثاً',
    Onlineauctions: 'المزادات عبر الإنترنت',
    Liveauctions: 'المزادات المباشرة',
    Auctionhistory: 'سجل مشتريات المزاد',
    Editorspicks: 'اختيارات المحررين',
    Apply: 'تطبيق',
    Resetfilters: 'إعادة ضبط المرشحات',
    Searchresults: 'نتائج البحث',
    Objects: 'القطع',
    Type: 'النوع',
    Historical: 'تاريخية',
    Myauctions: 'المزادات الخاصة بكم',
    Mysaved: 'القطع المحفوظة',
    Discovermore: 'قد يعجبكم أيضاً',
    Additionalinfo: 'معلومات إضافية',
    Productcondition: 'حالة القطعة',
    ProductCondition1Desc: 'ما تزال القطعة الأصلية بحالة ممتازة تُظهر أناقتَها الخالدة والحِرفية الفائقة في تصنيعها.',
    ProductCondition2Desc: 'ما تزال القطعة الأصلية بحالة ممتازة تُظهر أناقتَها الخالدة والحِرفية الفائقة في تصنيعها.',
    ProductCondition3Desc: 'ما تزال القطعة الأصلية بحالة ممتازة تُظهر أناقتَها الخالدة والحِرفية الفائقة في تصنيعها.',
    ProductCondition4Desc: 'العناصر المصنَّفة على أنَّها مستخدَمة قد لا تُظهر بالضرورة علامات الاستخدام، لكنها قد تكون ارتُديت من قِبل الشخصية الرياضية في حدث رياضي واحد أو أكثر.',
    ProductCondition6Desc: 'العناصر المصنَّفة على أنَّها مستخدَمة قد لا تُظهر بالضرورة علامات الاستخدام، لكنها قد تكون ارتُديت من قِبل الشخصية الرياضية في حدث رياضي واحد أو أكثر.',
    Productdetails: 'تفاصيل القطعة',
    CommingUpNext: 'التالي',
    Exteriormaterial: 'الخامة الخارجية',
    Interiormaterial: 'الخامة الداخلية',
    Hardware: 'الإكسسوارات المعدنية',
    Size: 'المقاس (الطول*العرض*الارتفاع)',
    Movementtype: 'نوع الحركة',
    CountryofOrigin: 'بلد المنشأ',
    Yearofproduction: 'سنة الإنتاج',
    Includings: 'المرفقات',
    waterResistance: 'مقاومة الماء',
    caseMaterial: 'خامة الهيكل',
    braceletMaterial: 'خامة السوار',
    makeofferdesc: 'هل السعر مرتفع للغاية؟ يمكنكم تقديم عرض للبائع وإخباره بالسعر الذي تريدونه',
    Okay: 'حسناً',
    SellBannerWords: 'في فالكونز، كنوزٌ خالدةٌ تتجاوز حدودَ الزمن.',
    Howitworks: 'كيف يتم الأمر',
    Step: 'الخطوة',
    Preliminaryquotation: 'الخطوة 1 عرض السعر الأولي',
    font01: 'قدِّموا قطعتكم عبر الإنترنت ليعطيكم فريقُنا تسعيراً أولياً.',
    Secondaryquotation: 'الخطوة 2 ترتيب الاستلام',
    font02: 'إذا كنتم راضين عن السعر، يمكنكم ترتيب استلام مجاني للتحقُّق من الأصالة والتسعير النهائي.',
    Listing: 'الخطوة 3 الإدراج والربح',
    font03: 'بعد قبول القطعة، سنقوم بتحسينها والتقاط صور عالية الدقة لها، ثم سندرجها في قوائمنا. بمجرَّد بيع القطعة، سيُضافُ المبلغ المستحَق إلى محفظة فالكونز الخاصة بكم.',
    quotationRejectedTitle: 'تم رفض الاقتباس',
    quotationRejectedContent1: 'شكرا لردكم.',
    quotationRejectedContent2: 'سيتواصل معك أحد أعضاء فريق خدمة العملاء لدينا قريبا.',
    Waystosell: 'طرق البيع',
    WaystosellAuction: 'طُرقٌ لبيع منتَجك في المزاد',
    WaystosellSell: 'طُرقٌ لبيع منتَجكم',
    auctionTip1: 'سيُحدَّد سعر البيع عبر المزايدة بين المشاركين، حيث إنَّ المُزايد الذي يعرض السعر الأعلى في الإطار الزمني المحدَّد سيتمكَّن من شراء القطعة.',
    auctionNow: 'اعرضوا قطعكم في المزاد الآن',
    sellTip1: 'تُعرض القِطعُ بأسعار ثابتة في متجرنا للمشتريات الفورية. بمجرَّد التحقُّق من أصالة قِطعكم وقبولها، ستُضاف إلى قوائمنا.',
    sell: 'البيع',
    recentlyAuctioned: 'قطع تمت المزايدة عليها مؤخراً',
    Recentbids: 'قطع تم بيعها مؤخراً',
    BuyNow: 'الشراء الآن',
    VIPselling: 'البيع المخصص لكبار الشخصيات',
    VIPSellingInfo: 'هل ترغبون ببيع قطعكم الفاخر؟ اتركوا رقم هاتفكم ليتواصل معكم فريق خدمات استقبال وإرشاد كبار الشخصيات في غضون يوم عمل واحد لمساعدتكم وترتيب عملية استلام القطع',
    Toapply: 'التقديم هنا',
    FAQ: 'الأسئلة الشائعة',
    Blog: 'المدونة',
    missionAndVision: 'الرسالة والرؤية',
    pressAndNews: 'الصحافة والأخبار',
    Readytosell: 'هل أنتم مستعدون للبيع',
    vipWords: 'هل ترغبون ببيع قطعكم الثمينة بقيمة عالية؟ يُرجى ترك رقم هاتفكم ليتواصل معكم فريق خدمات استقبال وإرشاد كبار الشخصيات في غضون يوم عمل واحد لمساعدتكم وترتيب عملية استلام القطع. اتركوا الأمر لنا وسنهتم بكل شيء لأجلكم. هل تتطلعون إلى بيع قطعكم الفاخرة؟ يُرجى ترك رقم هاتفكم ليتواصل معكم فريق خدمات استقبال وإرشاد كبار الشخصيات في غضون يوم عمل واحد لمساعدتكم وترتيب عملية استلام القطع. اتركوا الأمر لنا وسنهتم بكل شيء لأجلكم.',
    Mobile: 'الهاتف المحمول',
    Pleaseenterthemobilephone: 'يرجى إدخال رقم الهاتف المحمول',
    Default: 'العنوان الأساسي',
    DeliveryAddress: 'عنوان التوصيل',
    ConfirmAddress: 'تأكيد العنوان',
    SendToVault: 'الإرسال إلى خزنة فالكونز',
    SendToVaultContent: 'تمتلك فالكونز خزنة احترافية مزودة بتقنيات أمان عالمية عالية المستوى للحفاظ على سلامة القطع بعناية فائقة. في حال لم تقرروا مكان تخزين قطعكم بعد، أو إذا كنتم ترغبون بالحصول على فرصة لإعادة بيعها، يمكنكم الوثوق بأننا سنحافظ على قطعكم التي قمتم بشرائها بأمان تام',
    WalletContent: 'الدفع من رصيد حسابكم الموجود في محفظة فالكونز الخاصة بكم',
    PayPal: 'باي بال',
    PaypalTitle: 'الدفع عبر PayPal (بالدولار الأمريكي)',
    PayPalContent: 'يمكنكم الدفع عن طريق محفظة باي بال الإلكترونية إذا كنتم تمتلكون حساباً على باي بال',
    Pay: 'الدفع',
    KeepLeastOne: 'يرجى حفظ عنوان واحد في الأقل',
    ChooseFirst: 'يرجى اختيار طريقة الشحن المتاحة أولاً',
    FillFormFirst: 'يرجى تعبئة النموذج أولاً',
    Locale: 'en_US',
    onProgress: 'جاري تأكيد الطلب',
    OrderConfirmed: 'لقد تم  معالجة طلبكم',
    OrderConfirmedContent: 'شكرًا لتسوقكم معنا',
    Order: 'الطلب',
    PaymentSuccessful: 'تم الدفع بنجاح',
    PaymentUnsuccessful: 'لم تنجح عملية الدفع',
    ContinueShopping: 'متابعة التسوق',
    ContactUs: 'تواصلوا معنا',
    pickupAt: 'يرجى الاستلام في',
    PaymentUnsuccessfulContent: 'يرجى تحديث تفاصيل الدفع. وإلا سيتم إلغاء الطلب بعد',
    Sellyouritem: 'بيع القطعة الخاصة بكم',
    Itemdetails: 'تفاصيل القطعة',
    Uploadphotos: 'تحميل الصور',
    sellFont01: 'i. يمكنكم تقديم معلومات قطعتكم عبر الإنترنت وسيقدم لكم موظفونا نطاق سعر تقديري',
    sellFont02: 'ii. إذا كنتم راضين عن السعر المعروض، يمكنكم إرسال القطعة إلى فالكونز وسنحدّث السعر بناءً على تقييمنا لها بعد معاينتها',
    sellFont03: 'iii. في حال كنتم ما تزالون راضين عن عرض الأسعار المحدَّث، سنلمِّع القطعة ونلتقط لها صوراً عالية الدقة ثمَّ ندرجها على الموقع. في حال كنتم ترغبون بالمتابعة، سنجهِّز القطعة للبيع وندرجها في قوائمنا عبر الإنترنت',
    Itemlocation: 'موقع القطعة',
    localtionFont01: 'سنقوم بترتيب عملية استلام القطعة من عنوانكم المسجل ونقلها إلى فالكونز',
    localtionFont02: 'إذا اشتريتم أي قطعة من فالكونز واحتفظتم بها في خزنة فالكونز، يمكنكم اختيار أي عنصر من مجموعاتكم المخزنة وإدراجه للبيع',
    sellmodeFont01: 'تُباع القطع في وضع المزاد. سيتم تحديد سعر البيع بناءً على مزايدات المشاركين. ستصبح القطعة ملكًا للمستخدم الذي يقدم أعلى سعر خلال الإطار الزمني المحدد ',
    sellmodeFont02: 'تُعرَض القطع بأسعار ثابتة في المتجر. يمكن لأي مستخدم تقديم طلب لشراء القطعة على الفور',
    Selectyouritem: 'اختاروا قطعتكم',
    Pleasechooseyouritem: 'يرجى اختيار قطعتكم',
    uploadText: 'لتحميل صورة، يرجى النقر هنا أو استخدام خاصية السحب والإفلات',
    uploadTitleText: 'يمكنكم أيضاً استخدام تطبيق فالكونز المخصَّص للجوال لالتقاط صور القطع وتحميلها. يرجى مسح رمز الاستجابة السريعة واتباع التعليمات.',
    Confirmandsubmit: 'التأكيد والإرسال',
    submitSuccessMsg: 'سيقوم فريقنا بمراجعة طلبك والتحقق من المنتج وتصنيفه بناءً على المعلومات المقدمة، ثم تقديم عرض أسعار تقديري',
    Addanotheritem: 'إضافة قطعة أخرى',
    sellanotheritem: 'إضافة قطعة أخرى',
    Backtohomepage: 'العودة إلى الصفحة الرئيسية',
    sellSubmitSuccessContent1: 'سيقوم فريقنا بمراجعة ومصادقة وتصنيف تقديمك بناء على المعلومات المقدمة لتقديم عرض أسعار دقيق. تحتفظ الصقور بالحق الحصري في تحديد سعر قطعتك بناء على المعلومات التفصيلية.',
    // sellSubmitSuccessContent2: 'تحتفظ الصقور بالامتياز الحصري لتحديد سعر العنصر الخاص بك ، بناء على المعلومات التفصيلية.',
    font10: 'إذا كانت لديكم أي أسئلة أو لم تستلموا عرض الأسعار بعد 48 ساعة، يرجى الاتصال بخدمة العملاء للحصول على المزيد من المساعدة.',
    Itemreview: 'مراجعة القطعة',
    itemApproved: 'مبروك! تمت الموافقة على العنصر الخاص بك',
    Shippingdetails: 'تفاصيل الشحن',
    Acceptmode: 'وضع الموافقة',
    Keeporiginalmode: 'الإبقاء على الوضع الأصلي',
    Rejectreturn: 'الرفض والإرجاع',
    Shippingwithdelivery: 'الشحن الذي يتعامل معه البائع',
    shippingFont01: 'يمكنكم اختيار خدمة التوصيل الخاصة بكم وإرسال القطعة إلينا',
    shippingFont02: 'إذا كنتم تعيشون في دبي، يمكنكم تسليم القطعة إلى مستودعنا',
    FanclonsAddress: 'الوحدة سي 20، سي 21 فيدر كوميرشال سينتر، العقار رقم 1479، منطقة معيصم 1، مدينة دبي للإنتاج، الإمارات العربية المتحدة',
    DropoffatFalcons: 'هل ترغبون بتسليم القطعة شخصياً إلى مستودع فالكونز؟.',
    shippingStep01Num: 'الخطوة 1',
    shippingStep01Title: 'طباعة قسيمة التغليف',
    shippingStep01Text: 'يرجى طباعة قسيمة التغليف وإرفاقها بالحزمة',
    shippingStep02Num: 'الخطوة 2',
    shippingStep02Title: 'إرسال القطعة',
    shippingStep02Text: 'يرجى إرفاق قسيمة التغليف المطبوعة وإرسالها مع القطعة إلى العنوان:',
    shippingStep03Num: 'الخطوة 3',
    shippingStep03Title: 'تحميل رقم التتبع',
    shippingStep03Text: 'بعد شحن القطعة، يرجى إرفاق رقم التتبع حتى نتمكن من تتبع عملية التوصيل.',
    Download: 'تحميل',
    Selectyourcourier: 'يرجى اختيار شركة التوصيل',
    Trackingnumber: 'رقم التتبع',
    pickupByFalcons: 'أو بيك اب من الصقور',
    Acceptprice: 'قبول السعر',
    BacktoSellingItems: 'العودة إلى بيع القطع',
    Profilesettings: 'إعدادات الملف الشخصي',
    UnPaid: 'غير مدفوع',
    Paid: 'في انتظار المعالجة',
    PaidContent: 'لقد تلقى فريقنا طلبكم ويقوم بتجهيز القطعة الخاصة بكم الآن',
    ShippingInProgress: 'قيد الشحن',
    ShippingInProgressContent: 'تم تغليف وتسليم القطعة الخاصة بكم بواسطة شركة الخدمات اللوجستية التي نتعاون معها، وهي في الطريق إليكم الآن',
    Completed: 'اكتملت العملية',
    completeTitle: 'تم استكمال طلبكم',
    CompletedContent: 'لقد استلمتم القطعة الخاصة بكم الآن وتم إكمال الطلب. إذا كانت لديكم أي أسئلة، فلا تترددوا في الاتصال بفريق دعم العملاء الخاص بنا',
    Canceled: 'ملغى',
    Date: 'التاريخ',
    ShippingAmount: 'الشحن',
    ShippingFee: 'رسوم الشحن',
    ShippingDays: 'أيام الشحن',
    Mode: 'الوضع',
    Items: 'القطع',
    PhonePrefix: 'رمز الهاتف',
    ShippingDetail: 'تفاصيل الشحن',
    PaymentSuccessfulContent: 'شكراً لتسوقكم معنا',
    Shipping: 'الشحن',
    AddAddress: 'إضافة عنوان جديد',
    DropOffAtFW: 'هل ترغبون بتسليم القطعة شخصياً إلى مستودع فالكونز؟',
    IfyouDrop: 'إذا كنتم تعيشون في دبي، يمكنكم تسليم القطعة شخصياً إلى مستودعنا',
    FWAddress: 'العنوان:',
    Withdraw: 'سحب',
    Deliverypaymentmethod: 'طريقة التوصيل والدفع',
    Confirmationpayment: 'التأكيد والدفع',
    Withdrawitems: 'سحب القطع',
    DropOff: 'توصيل القطعة شخصياً',
    Purchase: 'شراء',
    CurrentInCart: 'حالياً في عربة التسوق',
    NotificationCenter: 'مركز الإشعارات',
    unread: 'غير مقروءة',
    read: 'مقروءة',
    yourBag: 'حقيبتك',
    goToBag: 'انتقل إلى الحقيبة',
    includingVat: 'بما في ذلك ضريبة القيمة المضافة',
    more: 'المزيد',
    CartSize: 'الحجم',
    Quantity: 'الكمية',
    Past: 'الرسائل السابقة',
    TrackingNumber: 'رقم التتبع',
    CanceledContent: 'تم إلغاء طلبكم',
    contactTitle01: 'تواصلوا معنا مباشرةً',
    contactText01: 'البريد الإلكتروني:',
    contactTitle02: 'يمكنكم زيارتنا شخصياً',
    contactText03: 'مقرنا:',
    contactText04: 'المستودع:',
    contactText05: 'غرفة المزاد:',
    Inquiryform: 'نموذج الاستفسار',
    Topic: 'الموضوع',
    DeliveryInformation: 'معلومات التوصيل',
    ReturnsAndRefunds: 'الإرجاع واسترداد الأموال',
    MyOrder: 'الطلب الخاص بكم',
    InternationalOrder: 'الطلبات الدولية',
    ProductInformation: 'معلومات القطعة',
    PromotionsMakeOffer: 'العروض الترويجية/تقديم عرض',
    Complaints: 'الشكاوى',
    TechnicalIssues: 'المشكلات التقنية',
    Message: 'إرسال رسالة',
    Submityourmessage: 'إرسال رسالتكم',
    Ascending: 'تصاعدياً',
    Descending: 'تنازلياً',
    mostpopular: 'الأكثر شعبية',
    Recentlyadded: 'قطع أضيفت مؤخراً',
    NewestFirst: 'الأحدث أولاً',
    OldestFirst: 'الأقدم أولاً',
    Bestcondition: 'أفضل حالة',
    Relevance: 'الصلة',
    CardBox:'علب البطاقات',
    pricelowtohigh: 'السعر:',
    pricehightolow: 'السعر:',
    Sellingtype: 'نوع البيع',
    lotnumberascending: 'رقم القطعة:',
    lotnumberdescending: 'رقم القطعة:',
    popularity: 'الشعبية',
    reservericeascending: 'سعر الحجز:',
    reservericedescending: 'سعر الحجز:',
    depositFont01: 'يُرجى التفويض بسحب مبلغ التأمين من بطاقة الائتمان الخاصة بكم',
    depositFont02: 'لماذا عليكم تفويض بطاقة الائتمان الخاصة بكم',
    depositFont03: 'نحاول توفير بيئة سليمة وآمنة لإقامة المزادات، لذلك نطلب من كل عميل التفويض بسحب مبلغ التأمين من بطاقة الائتمان لضمان أنَّ جميع المشترين سيدفعون مقابل القطعة التي يزايدون عليها. سيُلغى التفويض في حال لم تزايدوا على أي شيء أو إذا كنتم قد سددتم جميع فواتيركم، ولكن إذا لم تدفعوا المبلغ المستحَق عليكم خلال المدَّة الزمنية المحدَّدة، فسيتم خصم مبلغ التأمين',
    CreditCard: 'بطاقة الائتمان',
    WithdrawAmount: 'سحب المبلغ',
    PayoutMethod: 'طريقة الدفع',
    WithdrawContent: 'حددوا طريقة السحب أدناه. وقت السحب التقريبي 48 ساعة.',
    BankTransfer: 'تحويل بنكي',
    channelTypePlaceholder: 'حددوا طريقة الدفع المفضلة لديكم',
    YourBalance: 'رصيدكم',
    Amount: 'المبلغ',
    OrderID: 'رقم الطلب (إن وجد)',
    AccountholderName: 'اسم صاحب الحساب',
    AccountNumber: 'رقم الحساب',
    IbanNumber: 'رقم الحساب المصرفي الدولي (IBAN)',
    SwiftCode: 'رمز سويفت',
    BankName: 'اسم البنك',
    BranchName: 'اسم الفرع',
    inputUserName: 'يرجى إدخال اسمكم الكامل',
    inputEmail: 'يرجى إدخال بريدكم الإلكتروني',
    inputMessage: 'يرجى إدخال رسالتكم',
    PaypalAccount: 'حساب باي بال',
    LimitValidAmount: 'يرجى إدخال مبلغ صحيح',
    LimitTwoDecimal: 'يرجى إدخال خانتين عشريتين فقط',
    ExceedWithdraw: 'يتجاوز المبلغُ المحدد المبلغَ الذي يمكنكم سحبه',
    AskToReturn: 'طلب الاسترجاع',
    VerifyYourAccount: 'التحقق من حسابكم',
    VerifyYourAccountContent: 'سيقتصر وصولكم على متجر الشراء الفوري والمزادات عبر الإنترنت.',
    Trackyourparcel: 'تتبعوا قطعتكم',
    Carrier: 'شركة الشحن',
    Shippingupdates: 'تحديثات الشحن',
    Aramex: 'أرامكس',
    OrderNumber: 'رقم الطلب',
    Photo: 'صورة',
    Verify: 'تحقق',
    Popculturecollectibles: 'قطع الثقافة الشعبية',
    Sportmemorabilia: 'تذكارات رياضية',
    Sporttradingcardcollectibles: 'بطاقات التداول الرياضية',
    Heritagebrands: 'العلامات التجارية ذات الإرث التاريخي العريق',
    Carscollectibles: 'السيارات والقطع',
    Toyscomics: 'الألعاب والقصص المصورة',
    LouisVuitton: 'لوي فيتون',
    Hermes: 'هيرميس',
    Chanel: 'شانيل',
    Dior: 'ديور',
    Gucci: 'غوتشي',
    Rolex: 'رولكس',
    Omega: 'أوميغا',
    TagHeuer: 'تاغ هوير',
    Cartier: 'كارتييه',
    Breitling: 'بريتلينغ',
    banedTxt: 'عذراً، تم تعليق حسابكم لأنه ينتهك سياسة المستخدم الخاصة بنا. لمزيدٍ من المعلومات، يرجى الاتصال بنا',
    Refund: 'استرداد المبالغ',
    RefundContent: 'تم رد مبلغ الطلب بنجاح.',
    WelcomeTo: 'أهلاً بكم في',
    ContinueWithGoogle: 'المتابعة عبر حساب غوغل',
    ContinueWithFacebook: 'المتابعة عبر حساب فيسبوك',
    Or: 'أو',
    DownloadInvoice: 'تنزيل الفاتورة',
    Falcons: 'فالكونز',
    VipTier: 'درجة كبار الشخصيات',
    Verified: 'تم التحقق',
    Added: 'تمت إضافة القطعة',
    Auction: 'المزاد',
    sportsCards: 'البطاقات الرياضية',
    liveMultiSports: 'بيع بطاقات من مختلف الرياضات عبر البث الحي',
    onlineLiveShopping: 'التسوق المباشر عبر الإنترنت',
    collectorHistory: 'تاريخ المقتني',
    Handbags: 'حقائب اليد',
    Watches: 'الساعات',
    SportsCards: 'بطاقات التداول الرياضية',
    From: 'من',
    Add: 'إضافة',
    Brands: 'العلامة التجارية',
    Live: 'مباشر',
    Upcoming: 'القادم',
    Ongoing: 'الجاري',
    ResetYourPassword: 'إعادة تعيين كلمة المرور',
    ResetYourPasswordContent: 'يرجى إدخال البريد الإلكتروني المستخدم لتسجيل حسابكم وسنرسل لكم رابطاً لإعادة تعيين كلمة المرور.',
    CheckYourInbox: 'التحقق من صندوق الوارد الخاص بكم',
    CheckYourInboxContentFirst: 'تم إرسال رابط إعادة الضبط بنجاح إلى ',
    CheckYourInboxContentSecond: 'يرجى التحقق من صندوق البريد الوارد واتباع التعليمات الواردة في البريد الإلكتروني.',
    ResendLink: 'إعادة إرسال الرابط',
    SetYourNewPassword: 'تعيين كلمة المرور الجديدة',
    ConfirmNewPasswordContent: 'تم تحديث كلمة المرور الجديدة بنجاح.',
    ReceiveFalconsEmail: 'تلقي رسائل البريد الإلكتروني الترويجية من فالكونز',
    EmailPreference: 'تفضيلات البريد الإلكتروني',
    CountryOfResidence: 'بلد الإقامة',
    ShowDetails: 'عرض التفاصيل',
    SeeAllNotifications: 'عرض جميع الإشعارات',
    Thepricecannotbehigherthantheinitialprice: 'لا يمكن أن يكون السعر أعلى من السعر الحالي',
    CodeRule: 'يرجى إدخال كود التحقق المكون من أربعة أرقام.',
    VerificationEmail: 'إنجاز عملية التحقق من بريدكم الإلكتروني',
    AccountCreatedContent: 'للوصول إلى الميزات الكاملة للمزاد، عليكم تأكيد هويتكم.',
    AccountHasbeenCreated: 'تم إنشاء الحساب',
    WeHaveSentCode: 'أرسلنا كود التحقق إلى',
    CheckInboxCode: ' لتأكيد عنوان بريدكم الإلكتروني، يرجى التحقق من صندوق الوارد وإدخال الكود هنا',
    ComingSoon: 'قريباً!',
    Estimateprice: 'السعر المقدر',
    PleaseuploadaFrontandBackPhoto: 'يرجى تحميل جميع الصور المطلوبة',
    Yes: 'نعم',
    No: 'لا',
    Delivery: 'التوصيل',
    Payment: 'التأكيد والدفع',
    DeliveryMethod: 'عنوان التوصيل',
    Gotopurchase: 'الذهاب إلى المشتريات',
    Backtolots: 'العودة إلى القطع',
    AddYourPhoneNumber: 'إضافة رقم هاتفكم',
    AddYourPhoneNumberContent: 'يجب على العملاء إنجاز عملية التحقق من أرقام هواتفهم للدفع والانضمام إلى المزادات. إذا لم تنجزوا عملية التحقق من رقم الهاتف، ما يزال بإمكانكم تصفح موقعنا الإلكتروني.',
    VerifyYourPhoneNumber: 'إنجاز عملية التحقق من رقم هاتفكم',
    VerifyYourPhoneNumberContent: ' لإنجاز عملية التحقق من رقم هاتفكم، يرجى التحقق من الرسالة التي وصلتكم وإدخال الكود هنا',
    UploadImgMessage: 'يرجى تحميل ملف بتنسيق صورة',
    UploadPdfMessage: 'يرجى تحميل صورة أو ملف بصيغة PDF',
    EmailSentCode: 'أرسلنا رمزاً إلى بريدكم الإلكتروني، يرجى التحقق من صندوق الوارد وإدخال هذا الرمز هنا',
    Resend: 'إعادة إرسال',
    SendtoFalconsvault: 'الإرسال إلى خزنة فالكونز',
    vaultWords: 'تمتلك فالكونز خزنة احترافية مزودة بتقنيات أمان عالمية عالية المستوى للحفاظ على سلامة القطع بعناية فائقة. في حال لم تقرروا مكان تخزين قطعكم بعد، أو إذا كنتم ترغبون بالحصول على فرصة لإعادة بيعها، يمكنكم الوثوق بأننا سنحافظ على قطعكم التي قمتم بشرائها بأمان تام.',
    UploadSizeMessage: 'يجب أن يكون حجم الملف أقل من 10 ميغابايت',
    NewPasswordRule: 'يرجى إدخال كلمة مرور جديدة',
    AddressRule: 'يرجى إدخال عنوان صحيح',
    NewEmailRule: 'يرجى إدخال بريد إلكتروني جديد',
    SubmitOrder: 'تقديم الطلب',
    ReservePrice: 'حجز السعر',
    YourBid: ' المزايدات الخاصة بكم',
    YourBidWinsPrefix: 'مزايدتكم',
    YourBidWinsPostfix: 'فازت بالمزاد',
    YourBidLose: 'قدم شخص ما سعراً أعلى من سعر مزايدتكم',
    StartTimeAscending: 'وقت البدء:',
    EndTimeAscending: 'وقت الانتهاء:',
    Lotclosesat: 'تُباع القطعة عند:',
    Withdrawfee: 'رسوم السحب',
    PickUpAtFW: 'هل ترغبون باستلام القطعة من مستودع فالكونز؟',
    IfyouDropPickUp: 'إذا كنتم تعيشون في دبي، يمكنكم استلام القطعة من مستودعنا',
    SelectProductsFirst: 'يرجى اختيار المنتج أولاً',
    300001: 'البريد الإلكتروني أو كلمة المرور غير صحيحة. يرجى المحاولة مرة أخرى',
    310002: 'تم تسجيل هذا البريد الإلكتروني',
    310004: 'تم تسجيل هذا البريد الإلكتروني باستخدام غوغل أو فيسبوك أو آبل.',
    310101: 'لا يمكنكم تغيير البريد الإلكتروني عند تسجيل الدخول بحساب خارجي',
    330001: 'عذراً، لا يمكنكم تسجيل الدخول باستخدام هذا الحساب.',
    330002: 'عذراً، لم تنجزوا عملية التحقق من هويتكم',
    330003: 'عذراً، لا تلبي درجة كبار الشخصيات الخاصة بكم المعايير المطلوبة',
    330005: 'رمز التحقق غير صحيح.',
    330006: 'عذراً، لا يمكنكم المشاركة في أي مزاد بهذا الحساب.',
    540306: 'لا يمكنكم المزايدة على منتجكم الخاص.',
    402006: 'لا يمكنكم المزايدة على مقتنياتكم.',
    410010: 'عليكم الانضمام إلى المزاد أولاً.',
    420001: 'عذراً، لا يمكنكم المشاركة في أي مزاد بهذا الحساب.',
    550005: 'المبلغ يتجاوز مستوى المخزون الحالي',
    MaxTenAddress: 'يمكنكم حفظ ما يصل إلى 10 عناوين فقط',
    AdditionalinfoText: 'يُرجى الاطلاع على',
    and: 'و',
    TermsConditions: 'الشروط والأحكام',
    FAQs: 'الأسئلة الشائعة',
    PhoneRepeat: 'يرجى إدخال رقم هاتف جديد',
    items: 'القطع',
    FilterBy: 'التصفية حسب',
    reviewText: 'مراجعة المعلومات التي قمتم بتقديمها',
    submittingText: 'شكراً على الإرسال',
    maxBidTxt: 'إذا تم تعيين حد أقصى للمزايدة، ستقوم المنصة بتقديم عروض أسعار متزايدة نيابةً عنكم، وصولاً إلى الحد الأقصى المحدد للمبلغ.',
    January: 'يناير',
    February: 'فبراير',
    March: 'مارس',
    April: 'أبريل',
    May: 'مايو',
    June: 'يونيو',
    July: 'يوليو',
    August: 'أغسطس',
    September: 'سبتمبر',
    October: 'أكتوبر',
    November: 'نوفمبر',
    December: 'ديسمبر',
    MODELYear: 'سنة الموديل',
    PM: 'مساءً',
    AM: 'صباحاً',
    Sold: 'مُباع',
    BirthDOB: 'تاريخ الميلاد',
    Search: 'بحث',
    About: 'نبذة عنا',
    Authenticity: 'الأصالة',
    Aboutus: 'نبذة عنا',
    DeliveryPayment: 'التوصيل والدفع',
    Other: 'أخرى',
    PrivacyPolicy: 'سياسة الخصوصية',
    TermsofService: 'الشروط والأحكام',
    Customers: 'العملاء',
    Privacy: 'الخصوصية',
    Categories: 'الفئات',
    Mobileapp: 'تطبيق الهاتف المحمول',
    falconsReserved: 'ذا فولتد كارد©{yearMonth}. جميع الحقوق محفوظة. سياسة الخصوصية.',
    Pleaseenterthecorrectprice: 'يرجى إدخال السعر الصحيح',
    mobileTxt: 'لتحسين تجربة التسوق عبر الهاتف المحمول، يرجى تحميل تطبيقنا',
    Continuewithbrowser: 'المتابعة على المتصفح',
    ResendCode: 'إعادة إرسال الرمز',
    ConfirmDeleteItem: 'تأكيد حذف هذه القطعة من عربة التسوق؟',
    ByPlacingOrder: 'بتقديمكم الطلب، أنتم توافقون على',
    TermsOfFalcons: ' الخاصة بفالكونز',
    SubmitOrderCondition: '"بتقديمكم الطلب، أنتم توافقون على شروط وأحكام فالكونز',
    OurOffice: 'مكتبنا',
    Filter: 'تصفية',
    Concessions: 'الامتيازات',
    SConcept: 'ذي إس كونسيبت',
    discoverSConcept: 'اكتشف ذا اس كونسبت',
    aboutFalcons: 'نبذة عن فالكونز',
    aboutFalconsContent: 'فالكونز هي وجهة رائدة للفخامة. نحن نقدم مزادات عبر الإنترنت ومباشرة بالإضافة إلى مبيعات خاصة للمقتنيات النادرة والقطع الفاخرة للغاية. نعتقد أن الجمال الحقيقي للقطع الأيقونية يكمن في قدرتها على إثارة الإعجاب وإلهام ورواية قصص غير عادية. يتم تنظيم مزاداتنا ومبيعاتنا الخاصة بعناية لتقديم مجموعة رائعة من القطع الفاخرة لعملائنا الكرام.',
    WhyFalcons: 'لماذا البيع على فالكونز؟',
    WhyFalconsContent: 'فالكونز هي سوق موثوقة وديناميكية للسلع الفاخرة. مع فريقنا من المتخصصين، يمكننا مساعدتك في الحصول على أقصى استفادة من قطعك من خلال الوصول إلى مجتمع المشترين لدينا. تضمن "خدمة القفازات البيضاء" المتميزة لدينا أن تجربتك على منصتنا ليست فعالة فحسب، بل وأيضًا فردية للغاية، وتلبي احتياجاتك وتوقعاتك المحددة.',
    HowSellWithFalcons: 'كيف تبيع على فالكونز؟',
    HowSellWithFalconsContent: 'ابدأ بإنشاء حساب عبر الإنترنت وإرسال العناصر الخاصة بك. سيقدم فريق المتخصصين لدينا نطاقًا للأسعار بناءً على رؤيتهم لبيع العنصر الخاص بك. إذا كنت راضيًا عن السعر المحدد وأعدنا التقييم شخصيًا، فسنقوم بإعداد العنصر الخاص بك للبيع وإدراجه عبر الإنترنت.',
    WhatIsFalcons: 'ما هو فالكونز؟',
    WhatIsFalconsContent: 'فالكونز هي وجهة رائدة للفخامة. نحن نقدم مزادات عبر الإنترنت ومباشرة بالإضافة إلى مبيعات خاصة للمقتنيات النادرة والقطع الفاخرة للغاية. نعتقد أن الجمال الحقيقي للقطع الأيقونية يكمن في قدرتها على أسر وإلهام ورواية قصص غير عادية. يتم تنظيم مزاداتنا ومبيعاتنا الخاصة بعناية لتقديم مجموعة رائعة من القطع الفاخرة لعملائنا الكرام. مع شغفنا بالفنون وتقديرنا العميق للحرفية، نسعى جاهدين لخلق تجربة لا مثيل لها لهواة الجمع وعشاق الفن على حد سواء. يجوب فريق الخبراء لدينا العالم بلا كلل للحصول على كنوز نادرة ورائعة، مما يضمن أن عروضنا تعرض قمة الإبداع والأصالة والرقي. <br/> ما يميز فالكونز هو التزامنا الثابت بأقصى درجات الخصوصية والحصرية لعملائنا الكرام. نحن ندرك أن اقتناء قطع استثنائية هو تجربة شخصية بطبيعتها، ونقوم بتصميم خدماتنا لضمان أن تكون رحلتك معنا استثنائية حقًا. سواء كنت تتطلع إلى إضافة المزيد إلى مجموعتك الحالية، أو تبحث عن تحفة فنية بعيدة المنال، أو ببساطة تستكشف عالم الفخامة، فإن فريقنا المتحفظ والواسع الاطلاع موجود هنا لإرشادك في كل خطوة على الطريق. كما نقدم منصة للبائعين لبيع قطعهم الفاخرة المستعملة وإيجاد منازل جديدة لها. تتمثل رؤيتنا في تعزيز مجتمع يحتفل بشغف المقتنيات النادرة. من خلال مبيعاتنا الخاصة ومزاداتنا، نوحد بين هواة الجمع والخبراء والمحترفين في الصناعة، وننشئ منصة تغذي تقدير الفخامة في جميع أنحاء العالم. انضم إلينا في هذه الرحلة المبهجة بينما نفتح الأبواب إلى عالم مليء بالجمال الاستثنائي والأناقة الخالدة وإثارة اكتشاف روائع غير عادية. مرحبًا بكم في فالكونز، حيث لا حدود للسعي إلى الفخامة.',
    Others: 'أخرى',
    PreviousSearches: 'عمليات البحث السابقة',
    AllResults: 'كل النتائج',
    AllHandbags: 'كل حقائب اليد',
    AllWatches: 'كل الساعات',
    Minimum: 'الحد الأدنى',
    errorText: 'لقد طرأ خطأ ما. يرجى المحاولة مرة أخرى',
    310013: 'الرمز غير صحيح',
    suggest01: 'نعتقد أن قطعتكم مناسبة أكثر لوضع',
    suggest02: 'هل ترغبون بتغيير وضع البيع الخاص بكم؟',
    endTimeAscending: 'وقت الانتهاء:',
    startTimeAscending: 'وقت البدء:',
    mostPopular: 'الأكثر شعبية',
    currentPriceAscending: 'السعر الحالي',
    currentPriceDescending: 'السعر الحالي',
    AboutToOpen: 'على وشك الافتتاح',
    Open: 'مفتوح',
    Deatilshere: 'التفاصيل هنا',
    ShowCatelog: "إظهار الكتالوج",
    verifiedText: 'لم يتم التحقق من هويتكم.',
    Verifynow: 'إنجاز عملية التحقق الآن',
    Doitlater: "القيام بذلك لاحقًا",
    registeredText: 'لم تسجلوا رقم هاتفكم.',
    Doitnow: 'التسجيل الآن',
    testFont: 'أويستر كوزموغراف',
    Pristine: 'لا يزال بحالته الأصلية',
    Excellent: 'بحالة ممتازة',
    Good: 'بحالة جيدة',
    Fair: 'بحالة مقبولة',
    ad_font01: 'بيع القطعة الخاصة بكم على موقع فالكونز',
    ad_font02: 'هل تتساءلوا عن قيمة مجموعاتكم؟ هل تمتلئ خزانتكم بالكثير من الحقائب المصنوعة على يد مصممين عالميين وتودون بيعها؟ هل ترغبون بتحديث مجموعة ساعاتكم؟ يمكنكم البيع مع فالكونز وسيساعدكم فريقنا المحترف في الحصول على أفضل قيمة للقطع الخاصة بكم.',
    ad_button: 'بيع القطع',
    WelcomeToFalconsHome: 'مرحباً بك في ذا فولتد كارد',
    AuctionwithFalcons: 'شاركوا في المزادات مع فالكونز',
    Asymphony: 'حيث ينتظركم كلُّ ما هو استثنائيٌّ وفريد.',
    TYPESOFAUCTIONSATFALCONS: 'أنواع المزادات في فالكونز',
    SignupHome: 'التسجيل',
    Onlinetext: 'المزادات عبر',
    Auctionstext: 'الإنترنت',
    OnlineAuctions: 'الإنترنت',
    LivetextAuctions: 'المباشرة',
    HybridtextAuction: 'الهجينة',
    Hybridtext: 'المزادات',
    AUCTIONJOURNEY: 'رحلة المزاد',
    VIEWPRODUCTPAGE: 'عرض صفحة المنتج',
    WAITFORBIDSTATUS: 'انتظر حالة المزاد',
    BIDANDMAKEANOFFER: 'زايد وقدِّم عرضاً',
    Livetext: 'المزادات',
    VIEWLOTS: 'عرض القِطع',
    Orchestratingarefinedsymphony: 'تنسيق سيمفونية راقية من العروض والرغبات.',
    Experiencethepinnacle: 'ادخلوا في عالَم من الرُّقي في تجربةٍ ملؤها الفخامةُ والمرونة مع المزادات الهجينة في فالكونز، حيث يجتمع أفضلُ ما في العالَمين، في مزيجٍ سلسٍ من المزادات عبر الإنترنت والأجواء المثيرة لأحداث المزادات المباشرة. سواء اخترتم المشاركة شخصياً في أماكننا الفخمة أو المشاركة عن بُعد من خلال منصَّتنا المتطورة عبر الإنترنت، سيكون لديكم وصولٌ حصريٌّ إلى مجموعة مختارة بعناية فائقة من المقتنيات الفريدة الخاضعة لأدقِّ اختبارات الأصالة. ',
    Ourliveauctionsoffer: 'تتيح لكم مزاداتُنا المباشرةُ فرصةً فريدةً لتغمروا أنفسَكم في جوٍّ من الحصرية والهيبة والفخامة. ستحظون بفرصةِ المزايدة على أندر القطع وأروعها، محاطين بجوٍّ لا مثيل له من نخبة جامعي القطع الفريدة المتحمِّسين والمميزين. يضمن مقدِّمو المزادات المتميزون وخُبراءُ التحقُّق من الأصلة لدينا عمليةً شفَّافة لا تُضاهى، ما يضمن أنَّ كلَّ لحظة تعيشونها معنا لا تُنسى. ',
    Gainaccesstoacurated: 'استمتعوا بالوصول إلى مجموعة مختارة من أرقى الساعات وأفخم حقائب اليد وأندر البطاقات الرياضية الأكثر طلباً في العالم وأكثر من ذلك بكثير. تضمن منصَّتُنا المتطوِّرة عبر الإنترنت تجربةَ مزادات سلسة وآمنة، وتتفرَّد بقِطع تخضع لأدقِّ اختبارات الأصالة. ارتقوا بمجموعاتكم بسهولة ورُقيٍّ لا مثيلَ لهما من خلال المشاركة في مزاداتنا الحصرية عبر الإنترنت.',
    SetYourPassword: 'تعيين كلمة المرور الجديدة',
    ResetYourPasswordHome: 'إعادة ضبط كلمة المرور',
    CheckYourInboxHome: 'يرجى التحقق من صندوق الوارد الخاص بكم',
    VerificationEmailHome: 'يرجى التحقق من بريدكم الإلكتروني',
    AddYourPhoneNumberHome: 'يرجى إضافة رقم هاتفكم',
    VerifyYourPhoneNumberHome: 'يرجى التحقق من رقم هاتفكم',
    testFont01: 'ميني كيلي',
    testFont02: 'كيلي 25',
    testFont03: 'سي ماستر أكوا تيرا',
    testFont08: 'هيمالايا بيركين 25',
    testFont04: 'بيركين 30',
    testFont05: 'سبيد ماستر بروفيشنال',
    testFont06: 'كيلي لاكيس 35',
    testFont07: 'صبمارينر',
    testFont09: 'بيرد أون أ روك',
    ConfirmPasswordHome: 'تأكيد كلمة المرور',
    SignUpHome: 'التسجيل',
    Timepieces: 'الساعات',
    Memorabilia: 'تذكارات',
    ViewMore: 'عرض المزيد',
    DiscoverMore: 'اكتشفوا المزيد',
    scDISCOVERMORE: 'اكتشفوا المزيد',
    browseAuctions: 'تصفح المزادات',
    viewDetails: 'عرض التفاصيل',
    sneakerBannerTitle: 'أحذية جوردان 04',
    sneakerBannerContent: 'ارتقاء الأحذية الرياضية إلى مستوى المقتنيات المرغوبة في عالم الموضة الحضرية',
    sneakerBannerShop: 'تسوق الأحذية الرياضية',
    exploreSneakers: 'استكشف جميع الأحذية الرياضة',
    clothingBannerTitle: 'سوبريم',
    clothingBannerContent: 'قطع جوهرية مصممة لرفع مستوى ملابس الشارع اليومية',
    clothingBannerShop: 'تسوق المجموعة',
    exploreClothing: 'استكشف جميع الملابس',
    EXCLUSIVEAUCTION: 'مزاد حصري',
    HeritageUnveiled: 'كشف التراث',
    ConfirmDeleteSelectedItem: 'هل أنتم متأكدون من رغبتكم بحذف القطع المختارة',
    Whereprestige: 'حيث تلتقي الهيبة بالشغف، اشترك بامتيازٍ فريد للمزايدة على جوهر الفخامة.',
    Verifyyouraccount: 'تحقق من حسابك للمشاركة.',
    DateText: 'التاريخ: ',
    SeptemberText: '28 سبتمبر 2024',
    BurjAlArab: 'برج العرب',
    LocationText: 'الموقع: ',
    CATEGORY: 'الفئة',
    PRICE: 'السعر',
    GENDER: 'الجنس',
    BRANDS: 'العلامات التجارية',
    CONDITION: 'الحالة',
    STATUS: 'الحالة',
    ESTIMATEPRICE: 'السعر المقدر',
    CURRENTPRICE: 'السعر الحالي',
    TYPE: 'النوع',
    MYAUCTIONS: 'المزادات الخاصة بكم',
    DESCRIPTION: 'الوصف',
    detailTitle01: 'خدمات الشحن الدولي متاحة',
    detailText01: 'قد تُضاف الرسوم والضرائب الجمركية إلى قيمة الشحن.',
    detailTitle02: 'الضرائب غير مشمولة',
    detailText02: 'الأسعار المدرجة لا تشمل ضريبة القيمة المضافة والضرائب الأخرى.',
    detailTitle03: 'الأصالة مضمونة',
    detailText03: 'نضمن أصالة هذه القطعة.',
    Learnmore: 'الاطلاع على المزيد من التفاصيل',
    Readmore: 'قراءة المزيد',
    PRODUCTDETAILS: 'تفاصيل القطعة',
    PRODUCTCONDITION: 'حالة القطعة',
    Operate: 'التشغيل',
    DeleteOrder: 'حذف الطلب',
    deleteSuccess: 'تم حذف الطلب بنجاح!',
    search: 'بحث',
    MakeanofferSuccess: 'لقد قدمتم عرضاً جديداً بنجاح',
    AmountPaid: 'المبلغ المدفوع',
    adTitle01: 'بول نيومان/ دايتونا',
    adDec01: 'حرفية استثنائية من علامة الأزياء الشهيرة.',
    adButton01: 'تسوق الساعات',
    adTitle02: 'حقيبة يد سادل 2000',
    adDec02: 'حرفية استثنائية من علامة الأزياء الشهيرة.',
    adButton02: 'تسوق حقائب اليد',
    adTitle03: 'بيع القطع الخاصة بكم مع فالكونز',
    adDec03: 'سيساعدكم فريقنا المحترف في الحصول على أفضل قيمة للقطع الخاصة بكم',
    adButton03: 'بيع القطع الخاصة بكم معنا',
    OrderNo: 'رقم الطلب',
    EXPLORE: 'استكشفوا فئاتنا',
    noResults: 'لا توجد نتائج',
    arSreachTitle: 'تم العثور على ',
    arSreachMid: ' نتيجة في ',
    noResultAdvise: 'يرجى تجربة بحث مختلف.',
    bybrandTitle: 'من العلامة التجارية',
    UpperBuyNow: 'اشترِ الآن',
    upperMakeAnOffer: 'قدِّم عرضاً',
    shareProduct: 'مشاركة المنتَج',
    noResultRecommendTtile: 'استكشفوا أحدث القِطَع',
    noResultButtonText: 'عرض المزيد',
    AuthenticationGuarantee: 'ضماننا للأصالة',
    instructionBook: 'التزامُنا بالأصالة لا يتزعزع، فقبل أن تصل أيُّ قطعة إلى يديك، تخضع للفحص الدقيق من قِبل فريقنا من الخبراء في التحقُّق من الأصالة، كلٌّ منهم معتَمَدٌ في مجاله. إنَّهم يتحقَّقون بدقَّةٍ من أصالة كلِّ قطعة، ما يضمن أنَّ ما تتلقاهُ استثنائيٌ بجدارة.',
    instructionBookmodel: 'التزامُنا بالأصالة لا يتزعزع، فقبل أن تصل أيُّ قطعة إلى يديك، تخضع للفحص الدقيق من قِبل فريقنا من الخبراء في التحقُّق من الأصالة، كلٌّ منهم معتَمَدٌ في مجاله. إنَّهم يتحقَّقون بدقَّةٍ من أصالة كلِّ قطعة، ما يضمن أنَّ ما تتلقاهُ استثنائيٌ بجدارة.',
    Estimate_titleVideo: 'أوديمار بيغيه',
    Estimate_titleVideo_nav: 'انطلق إلى عالم من الفخامة مع مجموعة فالكونز الفريدة من الساعات، حيث تجسد كل ساعة هيبة خالدة.',
    Estimate_two_titleVideo: 'كومبليكايشنز ذهب وردي',
    Estimate_tw0_titleVideo_nav: 'استكشفوا قسم الأسئلة الشائعة لدينا، حيث ستجدون إجابات منسَّقة بدقة على استفساراتكم، ما يضمن تجربة سلسة وفخمة مع علامتنا التجارية المميزة.',
    generalTitle: 'مصمَّمةٌ لأكثر عُشَّاق جمع المقتنيات تميُّزاً.',
    OURWORLD: 'عالَمنا',
    newAbout: 'نبذة عنا',
    theWorldofFalcons: 'عالَم فالكونز',
    newAuthenticity: 'الأصالة',
    newFAQ: 'الأسئلة الشائعة',
    brandTitle: 'اختياراتنا من العلامات التجارية',
    historyTitle: 'مواضيع بحثت عنها سابقاً',
    clearSeach: 'مسح سجل البحث',
    recommadTitle: 'أبرز نتائج البحث',
    resultsFound: ' results found in ',
    noResultTitle: 'نعتذر - لا توجد نتائج لبحثك.',
    ChangeLanguageAnCurrency: 'Change Language & Currency',
    arChangeLanguageAnCurrency: 'اللغة والعملة',
    showingResultText: 'عرض النتائج لـ',
    FalconsReserve: "ذا فولتد كارد © {yearMonth}. جميع الحقوق محفوظة. سياسة الخصوصية.",
    newFalcons: 'فالكونز © 2024.',
    newReserve: 'ذا فولتد كارد©{yearMonth}. جميع الحقوق محفوظة. سياسة الخصوصية.',
    newVerifyAccount: 'حمِّل بطاقة هويتك',
    Latest: 'وصل',
    sports: 'الرياضة',
    Arrivals: 'حديثاً',
    factorCS: 'ترقَّبوا الافتتاح',
    VIEWDETAILS: 'عرض التفاصيل',
    isSold: 'مباعة',
    Change: 'تغيير',
    LanguageCurrency: 'اللغة/العملة',
    newDiscoverFalcons: 'تسوَّقوا المجموعة',
    Currency: 'اللغة',
    Language: 'العملة',
    enName: 'English',
    arNAME: 'العربية',
    aeCurrency: 'درهم إماراتي',
    usCurrency: 'دولار أمريكي',
    togoRouge: 'رويال أوك أوفشور',
    togoRougeList: 'الارتقاءُ بالفن والتراث والحصرية.',
    mobileApp: 'تطبيق الهاتف المحمول',
    newAuction: 'المزاد',
    newSell: 'البيع',
    newWishList: 'قائمة الرغبات',
    newNOTIFICATIONS: 'الإشعارات',
    VIEWALL: 'عرض الكل',
    newArrivals: 'وصل حدياً',
    SaveChanges: 'حفظ التغييرات',
    Estimate_two_titleVideo_model: 'رويال أوك أوفشور',
    Estimate_tw0_titleVideo_nav_model: 'الفنون والتراث والتفرد.',
    togoRouge_model: 'بيركين توڠو ٢٥',
    enquire: "استعلام",
    RequestPrice: "السعر عند الطلب",
    newFALCONS: 'الفئات',
    cardLive: 'فتح البطاقات',
    newLoginText: "إنشاء حساب {'|'} تسجيل الدخول",
    newLogin: 'تسجيل',
    Discovermorelink: 'استكشفوا هذه القِطعة',
    enquireTitle: "شكراً على إرسال طلب الاستعلام.",
    newSportsCards: 'المقتنيات',
    mobileEnquireTitle: "شكراً على تقديمك طلب الاستعلام.",
    enquireInfo: "سيتواصل معك أحد أعضاء فريق دعم العملاء لدينا قريباً.",
    back: "إلغاء",
    theSpconetitle: 'سوبريم',
    theSpconetitlelist: 'استكشفوا قسم الأسئلة الشائعة لدينا، حيث ستجدون إجابات منسَّقة بدقة على استفساراتكم، ما يضمن تجربة سلسة وفخمة مع علامتنا التجارية المميزة.',
    theSpconetitlelink: 'مرر لأسفل لاستكشاف المزيد',
    quotationRejected: 'تم رفض عرض السعر',
    quotationInfo: 'نشكرك على ردك.سيتواصل معك أحد أعضاء فريق خدمة العملاء قريباً.',
    theSpconetitlepage: 'استكشفوا قسم الأسئلة الشائعة لدينا، حيث ستجدون إجابات منسَّقة بدقة على استفساراتكم، ما يضمن تجربة سلسة وفخمة مع علامتنا التجارية المميزة.',
    sellthreecarty: 'الفئة',
    sellthreebarend: 'العلامة التجارية',
    sellthreedocut: 'نوع المنتَج',
    sellthreeAccessories: 'الملحقات (مثل الأحزمة والكتيبات على سبيل المثال)',
    sellthreeather: 'في حال وجود تفاصيل إضافية، يرجى كتابتها هنا.',
    actiontitle: 'اللقب',
    actiontitleh1: 'صفحة التسجيل للمشاركة في المعرض',
    actiontitlename: 'الاسم',
    actiontitlepnoe: 'رقم جهة الاتصال الأساسي:',
    actiontitlephoe: 'رقم جهة الاتصال الثانوي:',
    actiontitleexamet: 'البريد الإلكتروني:',
    actiontitledata: 'التاريخ والوقت',
    actiontitletime: 'الفترة الزمنية',
    actiontitlemer: 'ضيف واحد فقط.',
    actiontitleaout: ' يمكنك دعوة أي عدد من الضيوف',
    actiontitleaame: 'اسم الضيف:',
    actiontitlemr: 'السيد',
    actiontitlemrs: 'السيدة',
    actiontitlems: 'الآنسة',
    actiontitlefastname: 'الاسم الأول',
    actiontitlefastnames: 'اسم العائلة',
    auctionPN: 'رقم الهاتفr',
    auctionDialogTitle: 'استمر برحلة المشاركة في المزاد',
    auctionDialogContent: 'يُرجى دفع مبلغ الوديعة القابلة للاسترداد لحجز مقعدك في المزاد.',
    verifyTip: 'فقط المستخدمون الذين أتمّوا عملية التحقُّق يمكنهم حضور المعرض.',
    // actiontitlefastnexmsa:'Someone@example.com',
    actiontitlefastnexmsatime: 'التاريخ',
    actiontitleyes: 'نعم',
    actiontitleno: 'لا',
    actiontitlexiayi: 'تأكيد التسجيل',
    actiontitlequxiao: 'إلغاء',
    actiontitlenumberyi: 'من 7:00 مساءً حتى 8:00 مساءً',
    actiontitlenumberer: 'من 8:00 مساءً حتى 9:00 مساءً',
    actiontitlenumbersan: 'من 9:00 مساءً حتى 10:00 مساءً',
    actiontitlenumbersi: 'من 10:00 مساءً حتى 11:00 مساءً',
    actiontitlenumberwu: 'من 11:00 مساءً حتى 12:00 مساءً',
    upperEstimate: 'السعر التقديري',
    upperReserve: "الحد الأدنى للسعر",
    upperViewLots: "عرض القِطع",
    upperJoinTab: "المعرض",
    upperAuctinDetail: "تفاصيل المزاد",
    upperCondition: "شروط العمل",
    upperExhibition: "اختر موعد العرض الخاص بك",
    upperSlot: "الفترة الزمنية",
    auctionTermTab: "يرجى الاطلاع على شروط العمل عبر النقر على الرابط أدناه:",
    upperLocation: "المكان",
    upperDate: 'التاريخ',
    to: "حتى",
    time: 'الوقت',
    auctionRegisterText: 'يُرجى التسجيل من هنا للمشاركة في المزاد',
    auctionFinished: 'نتطلع إلى الترحيب بك في المزاد',
    auctionExhibitLog: 'يُرجى تسجيل الدخول لاختيار الفترة الزمنية لحضور المعرض',
    auctionExhibitSlot: 'اختر الفترة الزمنية لحضور المعرض',
    auctionExhibitBooked: 'تم حجز موعد حضور المعرض',
    mobileLogin: "يُرجى التسجيل من هنا للمشاركة في المزاد",
    gitldetale: 'التفاصيل هنا',
    gitldetalelist: 'التزامُنا بالأصالة لا يتزعزع، فقبل أن تصل أيُّ قطعة إلى يديك، تخضع للفحص الدقيق من قِبل فريقنا من الخبراء في التحقُّق من الأصالة، كلٌّ منهم معتَمَدٌ في مجاله. إنَّهم يتحقَّقون بدقَّةٍ من أصالة كلِّ قطعة، ما يضمن أنَّ ما تتلقاهُ استثنائيٌ بجدارة.',
    prolistfz: 'بحث',
    liveDesc: 'هنا تتجلَّى أساطير فتح علب بطاقات التداول الرياضية. لا تفوتوا لحظات السحب التي ستغير اللعبة.',
    countryNoData: 'غير موجود',
    PQuotations: 'التثمين الأوَّلي',
    sellModeDesc: `نعتقد أنَّ القَطعة الخاصة بك أكثر ملاءمة لوضع المزاد/لوضع الشراء. هل ترغب في تغيير وضع البيع الخاص بك؟`,
    pickShip: 'يُرجى اختيار طريقة الشحن',
    pickOtherShip: "اختر طريقة أخرى للشحن",
    rejectedDesc: 'فريق خدمة العملاء لدينا يراجع الآن رفضك لعرض السعر، وسيقدم لك عرض سعر محدَّث قريباً.',
    shipService: 'كجزء من خدمة القفازات البيضاء لدينا، أحدُ سائقينا الموثوق بهم سيستلم قطعتك.',
    shipByfalcons: 'الاستلام من قِبل فالكونز',
    shipedByfalcons: 'الاستلام من قِبل فالكونز | 48 ساعة',
    shipByfalconsInfo: 'سيقوم أحد السائقين الموثوقين لدينا باستلام قِطعتك شخصياً.',
    dropAtfalcons: 'التسليم إلى فالكونز',
    dropAtfalconsInfo: 'نرحب بك لزيارتنا لتسليم قِطعتك واستكشاف مجموعتنا المختارة من القِطع الفاخرة.',
    GoogleMap: 'الموقع على خرائط غوغل',
    updateQuotation: "التثمين المحدَّث",
    listingPrice: "السعر المقترح",
    rejectQuotatonDesc: "فريق خدمة العملاء لدينا يراجع الآن رفضك لعرض السعر، وسيقدم لك عرض سعر محدَّث قريباً.",
    sellerDetails: "تفاصيل البائع",
    finalQuotation: "عرض السعر النهائي",
    sellfromone: 'في حوزتي',
    sellfromtwo: 'خزنة فالكونز',
    sellfromlistone: 'إذا كانت القطعة في حوزتك، سنتواصل معك لتسليمها إلى مستودع فالكونز.',
    sellfromlisttwo: 'إذا كنت قد قمت بعملية شراء من فالكونز وقمت بحفظ القطعة في خزنتنا، فيمكنك الاختيار من مجموعاتك المحفوظة في الخزنة وإدراجها.',
    seellfromnoe: 'البيع',
    seellfromlistnoe: 'يتم إدراجُ القِطَع بسعرٍ ثابت في السوق.يمكن لأيِّ مستخدِم شراءُ القطعةوطلبها على الفور.',
    seellfromtwo: 'الوضع في المزاد',
    seellfromlisttwo: 'سيتم تحديد سعرِ البيع من خلال المزايدة بين المشاركين، حيث سيتمكَّن المزايدُ الذي يقدِّم أعلى سعر خلال الإطار الزَّمني المحدَّد من شراء القطعة.',
    selltitle: 'موقع القِطعة',
    selltitkebro: 'وضع البيع',
    selllistsch: 'اختر قِطعتك',
    sellMale: 'يرجى اختيار الجنس.',
    sellRolex: 'يرجى اختيار العلامة التجارة.',
    sellTimepiece: 'يرجى اختيار الفئة.',
    sellPleasetypehere: ' يرجى كتابتها هنا',
    sellTimepieces: 'يرجى اختيار الإكسسوارات.',
    sellyes: 'يرجى اختيار نعم أو لا.',
    sellPreloved: 'يرجى اختيار الحالة.',
    sellPleasetypeheresde: 'يرجى الكتابة هنا.',
    sellPrelovedndeo: 'صِف قِطعتك ببعض الجُمل.',
    sellCategory: 'الجنس',
    sellBrand: 'العلامة التجارية',
    sellProducttype: 'الفئة',
    sellthreecont: 'الإكسسوارات (مثل الأحزمة أو الكتيبات الإرشادية).',
    sellthreenode: 'في حال وجود تفاصيل إضافية، يرجى كتابتها هنا.',
    sellOtherIdesacp: 'الوصف',
    sellSelect: 'اختر قِطعتك',
    sellOtherIdesacpt: 'الوصف',
    categorys: 'الفئات',
    newDrops: 'وصل حديثاً',
    viewAll: 'عرض الكل'
}

export default ar
